import { render } from "./Tariffs.vue?vue&type=template&id=a91f103c"
import script from "./Tariffs.vue?vue&type=script&lang=js"
export * from "./Tariffs.vue?vue&type=script&lang=js"

import "./Tariffs.vue?vue&type=style&index=0&id=a91f103c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__